import { render } from "./ConfirmationModal.vue?vue&type=template&id=92748122&scoped=true"
import script from "./ConfirmationModal.vue?vue&type=script&lang=js"
export * from "./ConfirmationModal.vue?vue&type=script&lang=js"

import "./ConfirmationModal.vue?vue&type=style&index=0&id=92748122&scoped=true&lang=css"

import exportComponent from "/home/app-corporate-consiliumplus/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92748122"]])

export default __exports__